import { ArrowRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import claddingImg from '@/assets/cladding-detail.webp';

const CompanyOverview = () => {
  const { t } = useTranslation();

  const pillars = [
    { title: t('about.pillarSpeed'), desc: t('about.pillarSpeedDesc') },
    { title: t('about.pillarSustainability'), desc: t('about.pillarSustainabilityDesc') },
    { title: t('about.pillarResilience'), desc: t('about.pillarResilienceDesc') },
    { title: t('about.pillarRAK'), desc: t('about.pillarRAKDesc') },
  ];

  return (
    <section id="about" className="section-padding">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold mb-6 fade-in-up">{t('about.title')}</h2>
        <p className="text-lg text-muted-foreground leading-relaxed max-w-3xl mb-12 fade-in-up">
          {t('about.desc')}
        </p>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12">
          <div className="bg-primary/10 border border-primary/30 rounded-lg p-8 fade-in-up">
            <h3 className="text-xl font-bold mb-4">{t('about.differenceTitle')}</h3>
            <p className="text-muted-foreground leading-relaxed">{t('about.differenceDesc')}</p>
          </div>

          <div className="fade-in-up">
            <h3 className="text-xl font-bold mb-4">{t('about.pillarsTitle')}</h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {pillars.map((p) => (
                <div key={p.title} className="group flex gap-3 items-start">
                  <ArrowRight size={16} className="text-primary mt-1 shrink-0 group-hover:translate-x-1 transition-transform rtl:rotate-180 rtl:group-hover:-translate-x-1" />
                  <div>
                    <p className="font-semibold text-sm">{p.title}</p>
                    <p className="text-sm text-muted-foreground">{p.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="fade-in-up">
          <img
            src={claddingImg}
            alt="Modern container building with contemporary cladding in desert setting"
            className="w-full h-[300px] md:h-[400px] object-cover rounded-lg"
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
};

export default CompanyOverview;
